export default __webpack_public_path__ + "static/media/iga.99358879.jpeg";